import React from 'react';

import { Link } from 'react-router-dom';
import Logo from '../assets/images/GYM LOGO.png';

const Navbar = () => {
  return (

   
      <div className='container'>
        <nav class="navbar navbar-expand-lg bg-transparent">
          <div class="container-fluid">
            <Link to="/" class="navbar-brand">
              <img src={Logo} alt='Logo' style={{ width: '70px' }} />
            </Link>
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
              <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
              <ul class="navbar-nav  mb-2 me-auto mb-lg-0">
                <li class="nav-item" >
                  <Link to="/" class="nav-link active ms-5" aria-current="page"> <h4>Home</h4></Link>
                </li>
                <li class="nav-item">
                  <a href='#exercises' class="nav-link ms-5" ><h4>Exercise</h4></a>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>



  )
}

export default Navbar